import { render, staticRenderFns } from "./clasificadores.vue?vue&type=template&id=7353c7f7&"
import script from "./clasificadores.vue?vue&type=script&lang=js&"
export * from "./clasificadores.vue?vue&type=script&lang=js&"
import style0 from "./clasificadores.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports